module.exports = __webpack_public_path__ + "img/man.fc734066.jpg";